import { EmailVerificationStep } from "@pages/EmailVerification/EmailVerificationPage";
import { useForm } from "react-hook-form";
import { SEND_VERIFICATION_EMAIL_ROUTE } from "@api-routes/users";
import { getStateToPayload } from "../mappers/postEmailVerificationMapper";
import { useFetch } from "@common/hook/useFetch";
import { BRAND_NAME } from "@constants";

export const useEmailVerification = (setStep: (step: EmailVerificationStep) => void) => {
    const [postEmailVerificationState, { post }] = useFetch();

    const formMethods = useForm<{ email: string }>({ defaultValues: { email: "" } });

    const submitEmail = formMethods.handleSubmit((formData) => {
        post<boolean>(SEND_VERIFICATION_EMAIL_ROUTE, {
            body: getStateToPayload(formData.email, BRAND_NAME),
            isSecured: false,
        }).then((isEmailSent) => {
            if (isEmailSent) {
                setStep(EmailVerificationStep.success);
            }
        });
    });

    return { postEmailVerificationState, submitEmail, formMethods };
};
